import { FC, useRef, useState } from 'react';
import { LiveActivities } from '../../interface/LiveActivities.interface';
import { ActivityLoader } from './ActivityLoader';
import { NoActivity } from './NoActivity';
import { Activity } from './Activity';
import { LiveActivityContainer } from './LiveActivity.style';

interface LiveActivitiesProp {
	// activities: LiveActivities[];
	liveActivity: LiveActivities | undefined;
	liveActivityNo: number;
	loading?: boolean;
	refetch: () => {};
}

const LiveActivity: FC<LiveActivitiesProp> = ({ liveActivityNo, liveActivity, loading, refetch }) => {
	const activityBlock = useRef<HTMLDivElement>(null);

	if (loading) return <ActivityLoader />;

	return (
		<LiveActivityContainer>
			{liveActivity ? <Activity currentActivity={liveActivity!} ref={activityBlock} refetch={refetch} /> : <NoActivity />}
		</LiveActivityContainer>
	);
};
export default LiveActivity;
